import React, { useEffect } from 'react';
import { AxiosError } from 'axios';
import { Editor } from '../../libs/editor/components/Editor';
import { Loader } from '../../libs/shared/layout/Loader';
import { QlfMasterDetailContainer } from '../../libs/shared/layout/QlfMasterDetailContainer';
import { useEditorStore } from '../../libs/editor/store';
import { useFonts, useParticipantUrl, useTemplates } from '../../libs/editor/hooks';

function PageContent() {
  const currentTemplateId = useEditorStore(state => state.currentTemplateId);
  const setCurrentTemplateId = useEditorStore(state => state.setCurrentTemplateId);

  // React Query hooks handle fetching automatically
  const { templates, error: templatesError } = useTemplates();
  const { isLoading: isLoadingFonts } = useFonts();
  const { isLoading: isLoadingParticipantUrl } = useParticipantUrl();

  const loading = currentTemplateId === undefined || isLoadingFonts || isLoadingParticipantUrl;

  useEffect(() => {
    // select the last template by default or null to generate first template
    if (currentTemplateId === undefined) {
      if (templates.length > 0) {
        setCurrentTemplateId(templates[0].id || null);
      } else if ((templatesError as AxiosError)?.status === 404) {
        setCurrentTemplateId(null);
      }
    }
  }, [currentTemplateId, templates, templatesError, setCurrentTemplateId]);

  return loading ? <Loader /> : <Editor />;
}

export function EditorPage(): React.ReactElement {
  return (
    <QlfMasterDetailContainer>
      <PageContent />
    </QlfMasterDetailContainer>
  );
}
